import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getSelectableDefaultPages, getStoredDefaultPageSelection, parseDefaultPageOptionValue } from 'app/utils/defaultPageUtils';

/* Added the following code for POW-902.Harsha using AI Agent. August 19, 2026. Code Start */
const useStyles = makeStyles((theme) => ({
	modal: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'center',
		paddingTop: theme.spacing(4),
		zIndex: 1400,
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		borderRadius: '12px',
		boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
		padding: theme.spacing(3),
		width: '420px',
		maxWidth: '90%',
	},
	formControl: {
		width: '100%',
		marginTop: theme.spacing(2),
	},
	saveButton: {
		marginTop: theme.spacing(2),
	},
	saveButtonProgress: {
		color: '#fff',
		marginLeft: theme.spacing(1),
	},
}));

export default function DefaultPageModal(props) {
	const classes = useStyles();
	const [selectedValue, setSelectedValue] = useState('');
	const [pageOptions, setPageOptions] = useState([]);

	useEffect(() => {
		const pages = localStorage.getItem('Page') || '';
		setPageOptions(getSelectableDefaultPages(pages));
		setSelectedValue(getStoredDefaultPageSelection());
	}, [props.open]);

	function handleSubmit(event) {
		event.preventDefault();
		if (props.isSaving) {
			return;
		}
		props.submitDefaultPage(parseDefaultPageOptionValue(selectedValue));
	}

	function handleModalClose() {
		if (props.isSaving) {
			return;
		}
		props.handleClose();
	}

	return (
		<Modal
			aria-labelledby="default-page-modal-title"
			aria-describedby="default-page-modal-description"
			className={classes.modal}
			open={props.open}
			onClose={handleModalClose}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={props.open}>
				<div className={classes.paper}>
					<h3 style={{ fontSize: '16px', textAlign: 'center', fontWeight: 'bold', color: '#293B96' }}>
						Default Page
					</h3>
					<form
						name="defaultPageForm"
						noValidate
						className="flex flex-col justify-center w-full"
						onSubmit={handleSubmit}
					>
						<div style={{ borderBottom: '0.1px solid grey', marginTop: '10px' }} />
						<FormControl variant="outlined" className={classes.formControl}>
							<InputLabel id="default-page-select-label">Select default page</InputLabel>
							<Select
								labelId="default-page-select-label"
								id="default-page-select"
								value={selectedValue}
								onChange={(event) => setSelectedValue(event.target.value)}
								label="Select default page"
								disabled={props.isSaving}
							>
								<MenuItem value="">
									<em>Use system default</em>
								</MenuItem>
								{pageOptions.map((option) => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
						<Button
							variant="contained"
							color="primary"
							type="submit"
							aria-label="Save default page"
							className={classes.saveButton}
							disabled={props.isSaving}
						>
							{props.isSaving ? 'Saving' : 'Save'}
							{props.isSaving ? (
								<CircularProgress size={18} className={classes.saveButtonProgress} />
							) : null}
						</Button>
					</form>
				</div>
			</Fade>
		</Modal>
	);
}
/* Code end. Harsha using AI Agent. August 19, 2026 */
